import {Pipe, PipeTransform} from '@angular/core';
import lodashFilter from 'lodash-es/filter';

@Pipe({
    name: 'propertyFilter',
    pure: false
})
export class PropertyFilterPipe implements PipeTransform {
    transform(items: Array<any>, filter: Object): Array<any> {
        return lodashFilter(items, filter);
    }
}